import { PanelLeftOpen } from "lucide-react";

const SidebarToggler1 = ({ showSidebar, toggleSidebar, theme, className="pr-4 mr-4" }) => {
  // Show on screens <940px (tablet and mobile) when sidebar is closed
  return (
    !showSidebar ? (
      <div className={`border-r border-edge-gray-300 dark:border-edge-gray-700 ${className} hidden max-[939px]:block`}>
        <div className="sm:p-[1.5px]">
          <button
            type="button"
            className={`photon-rail-control h-8 w-8 sm:h-[39px] sm:w-[39px] cursor-pointer flex justify-center items-center rounded-lg ${
              theme === "dark" ? "hover:bg-fill-sidebar-surface-dark" : "hover:bg-fill-navigation-hover"
            }`}
            onClick={toggleSidebar}
            aria-label="Open sidebar"
          >
            <PanelLeftOpen size={20} className="text-ink-gray-500 dark:text-ink-gray-400" aria-hidden="true" />
          </button>
        </div>
      </div>
    ) : null
  );
};

export default SidebarToggler1;
